import React, { useState } from "react";
import GeneralConst from "../../consts/GeneralConst";
import GeneralStrings from "../../strings/GeneralStrings.json";
import AlertStrings from "../../strings/AlertStrings.json";
import Footer from "../../components/Footer/Footer";
import "./EnrollPage.scss";
import EnrollService from "../../services/EnrollService.js";
import { Helmet } from "react-helmet";
import HomepageNavbar from "../../components/HomepageNavbar/HomepageNavbar";
import EnrollForm from "../../components/EnrollForm/EnrollForm";
import { Alert } from "reactstrap";

const EnrollPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [sentMessage, setSentMessage] = useState(false);
  const [failedMessage, setFailedMessage] = useState(false);
  const [recaptchaLoad, setRecaptchaLoad] = useState(false);
  const STATUS_CODES = GeneralConst.STATUS_CODES;
  const ENROLL_STRINGS = GeneralStrings.ENROLL;
  const TITLE = `${ENROLL_STRINGS.BANNER_HEADING} | ${GeneralConst.SITE_NAME}`;

  const recaptchaLoaded = () => {
    setRecaptchaLoad(true);
  };

  const verifiedRecaptcha = (response) => {
    if (response) {
      setIsVerified(true);
    }
  };

  const resetErrorMessages = () => {
    setSentMessage(false);
    setFailedMessage(false);
  };

  const handleSubmit = (formValues) => {
    setIsLoading(true);
    resetErrorMessages();

    if (
      recaptchaLoad &&
      isVerified &&
      formValues.termsAndConditionsAcceptance.length > 0
    ) {
      EnrollService.submitEnrollRequest(formValues)
        .then((response) => {
          if (response.data.status === STATUS_CODES.ERROR) {
            setFailedMessage(
              response?.data?.statusMessage || AlertStrings.GENERAL_ERROR
            );
          } else {
            setSentMessage(
              response?.data?.statusMessage || AlertStrings.GENERAL_SUCCESS
            );
          }
        })
        .catch((response) => {
          setFailedMessage(
            response?.data?.statusMessage || AlertStrings.GENERAL_ERROR
          );
        })
        .finally(() => {
          setIsLoading(false);
          window.scrollTo(0, 0);
        });
    }

    setIsLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div className="enroll-page">
        <HomepageNavbar transparentNavbar={false} />
        <section className="page-banner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-7">
                <div className="banner-heading">
                  <h1>{ENROLL_STRINGS.BANNER_HEADING}</h1>
                  <p className="banner-subheading">
                    {ENROLL_STRINGS.BANNER_SUBTEXT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="enroll-container">
          <div className="container">
            <h3 className="header">{ENROLL_STRINGS.HEADER}</h3>
            <hr />
            {failedMessage && <Alert color="danger">{failedMessage}</Alert>}
            {sentMessage && <Alert>{sentMessage}</Alert>}
            <EnrollForm
              isLoading={isLoading}
              handleSubmit={handleSubmit}
              recaptchaLoaded={recaptchaLoaded}
              verifiedRecaptcha={verifiedRecaptcha}
            />
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default EnrollPage;
